<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">出版教材</div>
      <div class="rightbutton" @click="gotoaddpublish">我要出版</div>
    </div>
    <div class="inventory-box" :style="{height:`${tableViewHeight}px`}">
      <div class="headertable">
        <span class="hspan" style="width:280px">出版教材</span>
        <span class="hspan" style="width:280px">计划书名</span>
        <span class="hspan" style="width:150px">出版类型</span>
        <span class="hspan" style="width:150px">申请时间</span>
        <span class="hspan " style="width:120px">状态</span>
        <span class="hspan right" style="width:100px">操作</span>
        
      </div>
      <ul class="inventory-list">
        <li
          class="clearfix"
          v-for="(inventory, index) in lists"
          :key="index"
        >
          <span class="widthspan" style="width:280px">{{ inventory.topicName }}</span>
          <span class="widthspan" style="width:280px">{{inventory.projectTitle}}</span>
          <span class="widthspan" style="width:150px">{{textBookType[inventory.textbookType]}}</span>
          <span class="widthspan" style="width:150px">{{inventory.createTime}}</span>
          <span class="widthspan" style="width:200px" :class="statusText[inventory.auditStatus][0]" @click="showReason(inventory)">{{
            statusText[inventory.auditStatus][1]
          }}</span>
          <span class="widthspan buttoncao"
           style="width:100px"
            ><el-button
              @click.stop="dotodetail(inventory)"
              type="text"
              >详情</el-button
            >
            <el-button
              @click.stop="deletebutton(inventory)"
              type="text"
              >删除</el-button
            ></span
          >
        </li>
      </ul>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page="pageBean.pageNum"
        :page-size="pageBean.pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <el-dialog title="审核未通过原因:" :visible.sync="dialogVisible">
      <div>{{msg}}</div>
    </el-dialog>
  </div>
</template>
<script>
import { fetchPublishList,deletePublish,fetchReasonById } from '../../api/wapi';

export default {
  data() {
    return {
      lists: [],
      total: 0,
      msg:"",
      tableViewHeight:0,
      dialogVisible:false,
      pageBean:{
        pageNum:1,
        pageSize:10
      },
      textBookType:{
        8:"一般教材",
        5:"省规划教材"
      },
      statusText: {
        0: ['reviewe-rough', '未提交'],
        1: ['reviewe-delay', '待审核'],
        2: ['reviewe-finish', '审核通过'],
        3: ['reviewe-lose', '未通过'],
      },
    }
  },
  created() {
    this.gitList()
    this.$nextTick(()=>{
      this.tableViewHeight = window.innerHeight - document.getElementsByClassName("inventory-box")[0].offsetTop - 130
    })
  },
  methods: {
    gotoaddpublish() {
      this.$router.push('/center/publishbookadd')
    },
    handleCurrentChange(page) {
      this.pageBean.pageNum = page;
    },
    dotodetail(item) {
      this.$router.push({
        path:'/center/bookDetail',
        query:{fid:item.id}
      })
      console.log(item)
    },
    deletebutton(item) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
           deletePublish({
             ids : item.id
           }).then((result) => {
             this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.gitList();
           }).catch((err) => {
             
           });
          
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    showReason(data){
      if (data.auditStatus == 3){
          fetchReasonById({
            id:data.id
          }).then((result) => {
            console.log("=======>原因",result);
            this.msg = result&&result.data[0]['msg'];
            this.dialogVisible = true;
          }).catch((err) => {
            
          });
      }
    },
    // 清单详情
    showDetail(data) {
      // this.$router.push({
      //   path: '/center/listDetail',
      //   query: { fid: data.fid },
      // })
    },
    gitList() {
      fetchPublishList(this.pageBean)
        .then((res) => {
          console.log("sssceshi===>",res);
          this.lists = res&&res.data;
          this.total = this.page.total;
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style lang="scss" >
.buttoncao {
  height: 48px;
  display: flex;
  margin-top: 30px;
  align-items: center;
  .el-button{
    font-size: 14px;
  }
}

.widthspan button {
  padding-top: 0px;
}
.widthspan {
  display: inline-block;
  width: 170px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
  font-weight: bold;
}
.right{
  float: right;
}
.hspan{
  display: inline-block;
  width: 170px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: white;
}
.headertable {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  background-color: #274C9F;
  color: white;
}
.rightbutton {
  float: right;
  width: 120px;
  height: 40px;
  background: #274C9F;
  border: 1px solid #274C9F;
  border-radius: 4px;
  line-height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.catalogTit {
  display: inline-block;
}
.maincen {
  margin: 0 0px !important;
  min-height: 712px;
  // padding:0 20px;
  // background-color: white;
}
.catalog {
  overflow: hidden;
  padding: 0px 0 10px;
  line-height: 40px;
  .line {
    width: 8px;
    height: 18px;
    background: #274C9F;
    float: left;
    margin-right: 8px;
    margin-top: 11px;
  }
  .catalogTit {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
  }
}
</style>
<style lang="scss" scoped>
.deletebutton {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #a13e38;
}
.detailbutton {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9a2b;
}
.inventory-box {
  background-color: white;
  border: 1px solid #e6e6e6;
  border-bottom: 50px;
  width: 100%;
  .inventory-list {
    padding: 0 20px;
  }
}
.inventory-list li {
  font-family: Microsoft YaHei;
  // margin-top: 20px;
  display: flex;
  align-items: center;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px dashed #e6e6e6;
}

.inventory-list li h1 {
  width: 170px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
  margin-bottom: 20px;
  float: left;
  overflow: hidden;
}
.inventory-list li span {
  float: left;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
}
.inventory-list li span.reviewe-delay {
  color: #ff9a2b;
}
.inventory-list li span.reviewe-finish {
  color: #075a03;
}
.inventory-list li span.reviewe-rough {
  color: #999999;
}
.inventory-list li span.reviewe-lose {
  color: #0082F0;
}
.inventory-list li span.time a {
  text-decoration: none;
  outline: none;
  color: #999999;
}
.inventory-list li span.time {
  float: right;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
}
.inventory-list li span.time i {
  font-style: normal;
}
</style>
